export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8093.6acfa0d0.jpg";